var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        "body-class":
          "d-flex justify-content-center align-items-center flex-column",
        "modal-class": "lightbox",
        "hide-footer": "",
      },
      on: { hidden: _vm.onModalHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { class: _vm.headerClass }, [
                _vm.defaultCompare
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm compare",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleCompare.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-layout-split mr-1" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.compareMode ? "Preview" : "Compare") +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center title-buttons" },
                  [
                    !_vm.loading
                      ? _c("i", {
                          staticClass: "bi bi-share mr-3",
                          attrs: { title: "Copy share link" },
                          on: { click: _vm.handleShare },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.loading
                      ? _c("i", {
                          staticClass: "bi bi-clipboard mr-3",
                          attrs: { title: "Copy image (PNG/JPG)" },
                          on: { click: _vm.handleCopyToClipboard },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.loading
                      ? _c("i", {
                          staticClass: "bi bi-download mr-3",
                          attrs: {
                            title: _vm.compareMode
                              ? "Download comparison"
                              : "Download",
                          },
                          on: { click: _vm.downloadHandler },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "bi bi-x",
                      staticStyle: { "font-size": "20px" },
                      on: { click: _vm.hideModal },
                    }),
                  ]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("b-spinner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: { label: "Loading..." },
      }),
      _vm._v(" "),
      _vm.showLegibilitySingle
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center mb-3",
            },
            [
              _c(
                "span",
                {
                  staticClass: "text-sm mr-2",
                  staticStyle: { "font-weight": "600" },
                },
                [_vm._v("\n      Mobile Legibility\n    ")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "badge",
                  class: _vm.getLegibilityBadgeClass(_vm.afterScore),
                },
                [_vm._v("\n      " + _vm._s(_vm.afterScore) + "%\n    ")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && !_vm.compareMode,
              expression: "!loading && !compareMode",
            },
          ],
          staticClass: "image-wrapper",
        },
        [
          _c("div", { staticClass: "image-with-prompt" }, [
            _c("div", { staticClass: "image-container" }, [
              _c("img", {
                key: _vm.currentIndex,
                ref: "previewImage",
                staticClass: "preview-img",
                attrs: { src: _vm.currentImage.src },
                on: {
                  load: _vm.onLoad,
                  error: function ($event) {
                    return _vm.onMainImageError($event)
                  },
                },
              }),
              _vm._v(" "),
              _vm.currentIndex > 0
                ? _c(
                    "button",
                    {
                      staticClass: "lightbox-nav left",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.prev.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi bi-chevron-left" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex < _vm.images.length - 1
                ? _c(
                    "button",
                    {
                      staticClass: "lightbox-nav right",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.next.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi bi-chevron-right" })]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.showThumbnails && _vm.images && _vm.images.length > 1
              ? _c("div", { staticClass: "thumbnails-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "thumbnails-strip" },
                    _vm._l(_vm.images, function (img, index) {
                      return _c(
                        "button",
                        {
                          key: index,
                          staticClass: "thumbnail-button",
                          class: { active: index === _vm.currentIndex },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.goTo(index)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "thumbnail-image",
                            attrs: { src: img.src, alt: "" },
                            on: {
                              error: function ($event) {
                                return _vm.onThumbnailError(index, $event)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.currentImage.prompt && !_vm.loading
        ? _c("div", { staticClass: "mt-3 text-center" }, [
            _c(
              "p",
              {
                ref: "promptText",
                staticClass: "text-xs text-center prompt-text mb-1",
                class: { "prompt-text--collapsed": !_vm.promptExpanded },
              },
              [
                _c("strong", [_vm._v("Prompt:")]),
                _vm._v(" " + _vm._s(_vm.currentImage.prompt) + "\n    "),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-link p-0 text-muted text-xs shadow-none",
                on: {
                  click: function ($event) {
                    _vm.promptExpanded = !_vm.promptExpanded
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.promptExpanded ? "Show less" : "Show more") +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showLegibilityCompare
        ? _c("div", { staticClass: "w-100 mb-3" }, [
            _c("div", { staticClass: "text-center mb-2" }, [
              _c("span", { staticStyle: { "font-weight": "600" } }, [
                _vm._v("Mobile Legibility"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-around" }, [
              _c(
                "div",
                { staticClass: "text-center", staticStyle: { flex: "1" } },
                [
                  _c("span", { staticClass: "text-sm mr-1" }, [
                    _c("strong", [_vm._v("Before")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "badge",
                      class: _vm.getLegibilityBadgeClass(_vm.beforeScore),
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.beforeScore != null
                              ? `${_vm.beforeScore}%`
                              : "--"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center", staticStyle: { flex: "1" } },
                [
                  _c("span", { staticClass: "text-sm mr-1" }, [
                    _c("strong", [_vm._v("After")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "badge",
                      class: _vm.getLegibilityBadgeClass(_vm.afterScore),
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.afterScore != null ? `${_vm.afterScore}%` : "--"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.compareMode && !_vm.loading && _vm.comparePreviewSrc
        ? _c("img", {
            staticClass: "comparison-preview",
            attrs: { src: _vm.comparePreviewSrc },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }